import * as actions_authentication from 'actions/authentication-actions';
import React, { useState } from 'react';
import store from 'store';
import { useSelector } from 'react-redux';


export default function Navbar(props) {

    const company = useSelector((store) => store.company.company);

    function logOut(event) {
        event.preventDefault();
        store.dispatch(actions_authentication.logout());
    }

    return (

        <div className="row border-bottom white-bg" style={{ marginLeft: '80px' }}>
            <nav className="navbar navbar-expand-lg navbar-static-top" role="navigation">

                <span className="position-relative">
                    <button className="navbar-brand" style={{ border: 'none' }}>
                        <i className="fas fa-truck" aria-hidden="true"></i> &nbsp; TRUCKING &nbsp;
                        {process.env.REACT_APP_FIREBASE_ENV == 'development' &&
                            <small style={{ color: 'orange' }}>{process.env.REACT_APP_FIREBASE_ENV?.toUpperCase()}</small>
                        }
                        <span className="mx-2">|</span>
                        { company?.companyName }
                    </button>
                </span>

                <div className="navbar-collapse collapse" id="navbar">
                    <div className="navbar-header">
                        <a className="navbar-minimalize minimalize-styl-2 btn btn-primary" onClick={() => { props.toggleMenuCollapsed(); }}><i className="fa fa-bars"></i> </a>
                        <form role="search" className="navbar-form-custom" action="search_results.html">
                            <div className="form-group">
                                <input type="text" placeholder="Search for something..." className="form-control" name="top-search" id="top-search" />
                            </div>
                        </form>
                    </div>

                    <ul className="nav navbar-top-links">
                    </ul>
                </div>

                <ul className="nav navbar-top-links navbar-right">
                    <li className="dropdown">
                        <a className="dropdown-toggle count-info" data-toggle="dropdown" href="#">
                            <i className="fa fa-envelope"></i>  <span className="label label-warning">16</span>
                        </a>
                        <ul className="dropdown-menu dropdown-messages dropdown-menu-right">
                            <li>
                                <div className="dropdown-messages-box">
                                    <div className="media-body">
                                        <small className="float-right">46h ago</small>
                                        <strong>Mike Loreipsum</strong> started following <strong>Monica Smith</strong>. <br/>
                                        <small className="text-muted">3 days ago at 7:58 pm - 10.06.2014</small>
                                    </div>
                                </div>
                            </li>
                            <li className="dropdown-divider"></li>
                            <li>
                                <div className="dropdown-messages-box">
                                    <div className="media-body ">
                                        <small className="float-right text-navy">5h ago</small>
                                        <strong>Chris Johnatan Overtunk</strong> started following <strong>Monica Smith</strong>. <br/>
                                        <small className="text-muted">Yesterday 1:21 pm - 11.06.2014</small>
                                    </div>
                                </div>
                            </li>
                            <li className="dropdown-divider"></li>
                            <li>
                                <div className="dropdown-messages-box">
                                    <div className="media-body ">
                                        <small className="float-right">23h ago</small>
                                        <strong>Monica Smith</strong> love <strong>Kim Smith</strong>. <br/>
                                        <small className="text-muted">2 days ago at 2:30 am - 11.06.2014</small>
                                    </div>
                                </div>
                            </li>
                            <li className="dropdown-divider"></li>
                            <li>
                                <div className="text-center link-block">
                                    <a href="mailbox.html" className="dropdown-item">
                                        <i className="fa fa-envelope"></i> <strong>Read All Messages</strong>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li className="dropdown">
                        <a className="dropdown-toggle count-info" data-toggle="dropdown" href="#">
                            <i className="fa fa-bell"></i>  <span className="label label-primary">8</span>
                        </a>
                        <ul className="dropdown-menu dropdown-alerts">
                            <li>
                                <a href="mailbox.html" className="dropdown-item">
                                    <div>
                                        <i className="fa fa-envelope fa-fw"></i> You have 16 messages
                                        <span className="float-right text-muted small">4 minutes ago</span>
                                    </div>
                                </a>
                            </li>
                            <li className="dropdown-divider"></li>
                            <li>
                                <a href="profile.html" className="dropdown-item">
                                    <div>
                                        <i className="fa fa-twitter fa-fw"></i> 3 New Followers
                                        <span className="float-right text-muted small">12 minutes ago</span>
                                    </div>
                                </a>
                            </li>
                            <li className="dropdown-divider"></li>
                            <li>
                                <a href="grid_options.html" className="dropdown-item">
                                    <div>
                                        <i className="fa fa-upload fa-fw"></i> Server Rebooted
                                        <span className="float-right text-muted small">4 minutes ago</span>
                                    </div>
                                </a>
                            </li>
                            <li className="dropdown-divider"></li>
                            <li>
                                <div className="text-center link-block">
                                    <a href="notifications.html" className="dropdown-item">
                                        <strong>See All Alerts</strong>
                                        <i className="fa fa-angle-right"></i>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a title="logout" role="button" onClick={(event) => logOut(event)}>
                            <i className="fas fa-sign-out-alt fa-2x text-muted" style={{ fontSize: '18px' }}></i>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    );
}
